<template>
  <div>
    <v-row>
      <info :info.sync="data.version" title="Version" :cols="3" />
      <info :info.sync="created_date" title="Created Date" :cols="3" readOnly />
      <info
        :info.sync="last_activity"
        title="Last Activity"
        :cols="3"
        readOnly
      />
      <info :info.sync="phone" title="MDN" :cols="3" phone />
    </v-row>
    <v-row>
      <info
        :info.sync="data.launch_mode"
        title="Launch Mode"
        readOnly
        :cols="3"
      />
      <info
        :info.sync="data.car_number"
        title="Car Number"
        readOnly
        :cols="3"
      />
      <info
        :info.sync="cartStatus"
        title="Round Today"
        :cols="3"
        select
        :items="['In Use', 'Not In Use']"
      />
      <info :info.sync="data.imei" title="IMEI Number" readOnly :cols="3" />
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import FormatDate from '@/mixins/FormatDate';
import FormatPhone from '@/mixins/FormatPhone';
import ScreenDetailData from '@/mixins/ScreenDetailData';
import Info from '@/components/screens/Info';

export default {
  mixins: [ScreenDetailData, FormatDate, FormatPhone],
  components: {
    Info,
  },
  computed: {
    ...mapGetters({
      cartStatus: 'screenDetails/getCartStatus',
    }),
    last_activity: {
      get() {
        return this.formatDate(this.data.last_activity);
      },
    },
    created_date: {
      get() {
        return this.formatDate(this.data.created_at);
      },
    },
    phone: {
      get() {
        return this.formatPhone(this.data.phone_number);
      },
      set(val) {
        this.data.phone = val;
      },
    },
  },
};
</script>
